import { renderBlocksList } from './renderBlockList.js';
export function renderChildren({ block, options, children, extraProps, renderProps, }) {
    if (children) {
        return children;
    }
    return block && options
        ? renderBlocksList(block.blocks, { ...options, parent: block, extraProps, renderProps })
        : null;
}
//# sourceMappingURL=renderChildren.js.map